<template>
  <div class="home" style="padding: 0 30px 0 30px">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
       
    <!-- demo root element -->
    <div id="main-slider">
      <!-- <ImageSlider>
      </ImageSlider> -->
     <ImageSlider2/>
    </div>
    <div class="thong-tin col-md-12 row" >
       <h4>Thông tin</h4>
     </div>
    <!-- <div class="col-md-12 col-lg-12 col-ms-12 content " style="text-align:center;"> -->
      <!-- <div class=" col-md-4 col-lg-4 col-sm-4 mouse-hover" style="float:left" v-on:click="openContent1()">
        <img class=" col-md-12 col-lg-12 col-sm-12 mouse-hover" :src="imgContent1" style="width:310px;height:310px;margin-top:3px;"/> 
        <h3 class="mouse-hover">{{content1}}</h3>
      </div>
      <div class=" col-md-4 col-lg-4 col-sm-4 mouse-hover" style="float:left" v-on:click="openContent2()">
        <img class=" col-md-12 col-lg-12 col-sm-12 mouse-hover" :src="imgContent2" style="width:310px;height:310px;margin-top:3px;"/> 
        <h3 style="text-align:center">{{content2}}</h3>
      </div> -->
       <!-- <div class=" col-md-4 col-lg-4 col-sm-4 mouse-hover" style="float:left" v-on:click="openContent3()">
        <img :src="imgContent1" style="width:310px;height:310px;margin-top:3px;"/> 
        <h3 >{{content3}}</h3>
      </div> -->
    <!-- </div> -->
    <div  id="showDetailContent" v-if="isShowContent1 || isShowContent3 || isShowContent2 " class="show-detail-content col-md-12 row">
      <div v-if="isShowContent1" style="word-break: break-all" >
          <p  style="white-space: normal;word-break: break-all"> <span style="white-space:pre-line">{{content1Detail }}</span></p>
      </div>
      <div v-if="isShowContent2">
        <p  style="white-space: normal;word-break: break-all"><span style="color:blue"></span><br/> <span style="white-space:pre-line">{{content2Detail }}</span></p>
      </div>
      <!-- <div v-if="isShowContent3" >
        <h3  style="white-space: normal;word-break: break-all"> <span style="white-space:pre-line">{{content3Detail }}</span></h3 >
      </div> -->
    </div>
    <div class="thong-tin col-md-12" >
       <h4>Hướng dẫn</h4>
     </div>
     <div class="huong-dan">
       <p > <a  href="../huong-dan-gui-hang">1. Hướng dẫn gửi hàng thông qua bưu điện và yamato </a> </p>
       <p > <a  href="../chi-nhanh-vn">2. Xem chi nhánh tại việt Nam </a> </p>
       <p > <a  href="../chi-nhanh-jp">3. Xem chi nhánh tại Nhật Bản </a> </p>
     </div>
    
     
    <!-- <div class="thong-tin col-md-12 row" >
       <h4>Thành viên Mai Phuong Express</h4>
     </div>
     <div  id="showDetailContent" class="show-detail-content col-md-12 row"> -->
       <!-- style="word-break: break-all" -->
        <!-- <div class="col-md-2">
          <img :src="thanhVien_xuanhoai.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhVien_xuanhoai)" style="text-align: center !important; margin-bottom:7px; ">Xem thêm...</p>
         </div>
         <div class="col-md-2">
          <img :src="thanhvien_thuphong.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhvien_thuphong)" style="text-align: center !important; margin-bottom:7px">Xem thêm...</p>
         </div>
         <div class="col-md-2">
          <img :src="thanhvien_hoangduy.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhvien_hoangduy)" style="text-align: center !important; margin-bottom:7px">Xem thêm...</p>
         </div>
         <div class="col-md-2">
          <img :src="thanhvien_hanghang.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhvien_hanghang)" style="text-align: center !important; margin-bottom:7px">Xem thêm...</p>
         </div>
         <div class="col-md-2">
          <img :src="thanhvien_mailoan.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhvien_mailoan)" style="text-align: center !important; margin-bottom:7px">Xem thêm...</p>
         </div>
         <div class="col-md-2">
          <img :src="thanhvien_maihuyen.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhvien_maihuyen)" style="text-align: center !important; margin-bottom:7px">Xem thêm...</p>
         </div>
         <div class="col-md-2">
          <img :src="thanhvien_maile.img" width="50%" class="center">
          <p class="lien-he"  v-on:click="ShowMessager(thanhvien_maile)" style="text-align: center !important; margin-bottom:7px">Xem thêm...</p>
         </div>
    </div> -->
    <div class="thong-tin col-md-12" >
       <h4>Video</h4>
     </div>
    <div class="show-video col-md-12 col-lg-12 row" style="text-align:center !important">
      <div class="video-player col-md-4 col-lg-4">
        <iframe class="center" width="100%" height="300" :src="video01" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="video-player col-md-4 col-lg-4">
        <iframe  width="100%" height="300" :src="video02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="video-player col-md-4 col-lg-4">
        <iframe  width="100%" height="300" :src="video03" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
     </div>
    <div class="thong-tin col-md-12" >
       <h3>Liên hệ</h3>
     </div>
    <div class="col-md-12 thong-tin-lien-he"  style="margin-bottom:4em">
      <h4 style="color: blue;white-space:pre-line">FanPage Vận chuyển: <a href="https://www.facebook.com/pg/vanchuyenmaiphuong" target="blank"> Page Công ty vận chuyển >> click</a> </h4>
      <h4 style="color: blue;white-space:pre-line">FanPage Hàng nhật: <a href="https://www.facebook.com/HangChuanNhatMaiPhuongTokyo" target="blank">Page Hàng Nhật >> click</a> </h4>
      <h4 style="color: blue;white-space:pre-line">Địa chỉ tại Nhật: 270-1152千葉県我孫子市寿2-2-15 </h4>
      <h4 style="color: blue;white-space:pre-line">Địa chỉ tại Việt Nam: 43 Chu Văn An, Huế </h4>
      <h4 style="color: blue;white-space:pre-line">Zalo: (+81)9029111390 </h4>
      <h4 style="color: red;white-space:pre-line"> Email: maiphuong.tokyo@gmail.com </h4>
    </div>
    <transition v-if="showModal" name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header" >
                 <span style="font-weight: bold !important;"> {{modalName}}</span>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <img class="center" style="width:50%" :src="modalImage" />
                  <p>{{modalContent}}</p>
                </slot>
              </div>
              <!-- <div class="modal-body">
                <slot name="body">
                  <span class="gia">{{modalPrice}}</span>
                  <br>
                  <span class="sale">{{modalSale}}</span>
                </slot>
              </div> -->

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-danger" @click="closeImage()">
                    Đóng
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>
<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Constants from "@/components/Constants/Constants.js"
import LinkImage from "@/components/Constants/LinkImage.js"
import ImageSlider from "@/components/Slider/Slider.vue"
import ImageSlider1 from "@/components/Slider/Slider1.vue"
import ImageSlider2 from "@/components/Slider/Slider2.vue"
import MessagerModal from "@/components/MessagerModal/MessagerModal.vue"

import testapi from '@/services/api/test'

export default {
  name: 'Home',
  computed: {
    videoElement () {
      return this.$refs.video;
    }, 
  },
  components: {
    HelloWorld,
    ImageSlider,
    ImageSlider1,
    ImageSlider2,

  },
  
  data(){
        return{
        video01:"https://www.youtube.com/embed/REb-MPczRak",
        video02: "https://www.youtube.com/embed/LoiBQCIVeLM",
        video03: "https://www.youtube.com/embed/ycbKvg23wNE",
        img1: LinkImage.vanchuyenmaiphuong1,
        img2: LinkImage.vanchuyenmaiphuong2,
        img3: LinkImage.vanchuyenmaiphuong3,
        imgalt: LinkImage.vanchuyenmaiphuongalt,
        imgContent1: LinkImage.content_1,
        imgContent2: LinkImage.content_2,
        content1:"Tôi là ai >> click",
        content2:"Tôi làm gì >> click",
        content3:"Hỗ trợ",
        content1Detail:"Xin cám ơn bạn đã quan tâm đến thông tin về Mai Phuong Tokyo." + '\n'+
                "Xin tự giới thiệu mình là Mai Phuong, và hiện đang sinh sống và làm việc tại Nhật Bản" + "\n" +
                "Mình đến Nhật từ năm 2014. mình đã trải qua nhiều thăng trầm trong kinh doanh như việc mở nhà hàng món ăn Việt Nam, buôn bán đồ khô Việt Nam, mỹ phẩm Nhật...,  và "+
                "khi nhận thấy nhu cầu gửi hàng của các bạn du học sinh, thực tập sinh, kỹ sư...gửi hàng về Việt Nam cũng như việc gửi từ chiều ngược lại.Thì sau đó " +
                "mình đã quyết định mở công ty vận chuyển đề phục vụ nhu cầu vận chuyển. Ngoài ra để hỗ trợ GIẢM CHI PHÍ gửi hàng của khách hàng bên mình hỗ trợ order mua hộ hàng miễn phí,"+
                "cũng như việc kiêm luôn bán, order các mặt hàng nội địa Nhật Bản." ,
        content2Detail:
                "Mai Phương Express hiện là hệ thống vận chuyển hàng nội địa hai chiều Việt Nhật, thực hiện dịch vụ vận chuyển hàng hóa đi khắp mọi nơi  bằng đường biển, đường hàng không, công ty đặc biệt mạnh về dịch vụ vận chuyển hàng đi Nhật Bản và từ Nhật về Việt Nam với mức giá cạnh tranh mà ít công ty vận chuyển nào có thể đáp ứng được.Chúng tôi thực hiện vận tải cho hầu hết tất cả các loại hàng hóa và loại hình kinh doanh. Tùy từng loại hàng hóa mà chúng tôi có một qui trình vận tải chuẩn riêng nên quí khách hàng yên tâm về sự an toàn và tốc độ." + "\n"+
                "------------------------------------------------------" + "\n"+
                "- Vận chuyển 2 chiều Nhật - Việt" + "\n"+
                "- Sĩ lẽ mỹ phẩm, thực phẩm chức năng nội địa Nhật Bản" + "\n"+
                "- Hỗ trợ mua hộ các sản phẩm " + "\n"+
                "- Tư vấn miễn phí và hỗ trợ kinh doanh sản phẩm Nhật Bản" + "\n"+
                "- Tư vấn miễn phí các vấn đề liên quan đến xuất khẩu lao đông, du học ...Nhật Bản" + "\n",
        content3Detail:"Cập nhật",
        isShowContent1: false,
        isShowContent2: true,
        isShowContent3: false,

        thanhVien_xuanhoai:{img:LinkImage.thanhVien_xuanhoai,content:"Tôi là Lê Xuân Hoài, hiện đang là chuyên viên IT cho Mai Phuong Express",Name:"Le Xuan Hoai"},
        thanhvien_thuphong:{img:LinkImage.thanhvien_thuphong,content:"",Name:"Nguyen Thu Phong"},
        thanhvien_hanghang:{img:LinkImage.thanhvien_hanghang,content:"",Name:"Hang Hang"},
        thanhvien_hoangduy:{img:LinkImage.thanhvien_hoangduy,content:"",Name:"Hoang Duy"},
        thanhvien_maihuyen:{img:LinkImage.thanhvien_maihuyen,content:"",Name:"Mai Huyền"},
        thanhvien_mailoan:{img:LinkImage.thanhvien_mailoan,content:"",Name:"Mai Loan"},
        thanhvien_maile:{img:LinkImage.thanhvien_maile,content:"",Name:"Mai Le"},

        showModal: false,
        modalName:"",
        modalContent:"",
        }
    },
  created(){
    // localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
    sessionStorage.setItem(Constants.ITEM_HOME,"nav-bar active");
    // localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
    // localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
    console.log("home");
    console.log("home:",this.img1);
  },
  methods:{
    ShowMessager(img){
      console.log("abdd");
            this.showModal = true;
            this.modalImage = img.img;
            this.modalName = img.Name;
            this.modalContent = img.content;
            // this.modalTitle = img.title;
            // this.modalPrice = img.price;
            // this.modalSale = img.sale;
    },
    closeImage(){
      this.showModal = false;
    },
    openContent1(){
      this.isShowContent1 = true;
      this.isShowContent2 = false;
      this.isShowContent3 = false;
      setTimeout(() => {
        let element = document.getElementById("showDetailContent");
        element.scrollIntoView({behavior: "smooth", block: "end"});
      }, 100);
      console.log("content1");
    },
    openContent2(){
      this.isShowContent1 = false;
      this.isShowContent2 = true;
      this.isShowContent3 = false;
      setTimeout(() => {
        let element = document.getElementById("showDetailContent");
        element.scrollIntoView({behavior: "smooth", block: "end"});
      }, 100);
        console.log("content2");
    },
    openContent3(){
      this.isShowContent1 = false;
      this.isShowContent2 = false;
      this.isShowContent3 = true;
      setTimeout(() => {
        let element = document.getElementById("showDetailContent");
        element.scrollIntoView({behavior: "smooth", block: "end"});
      }, 100);
        console.log("content3");
    }
  },
  created(){
    console.log("aaaaaaaaaaaaaaaaaaa");
    testapi.getposts().then(post => {console.log(post);})
  }
}
</script>
<style scoped>
.home {
  margin-top: 140px;
}
.home .huong-dan{
  margin-left: 30px !important;
}
.content{
  height: 350px;
  width: 100%;
  border-top: yellow solid 1px;
  margin-bottom:1em ;
}
.mouse-hover{
  cursor: pointer;
}
.content div{
  border: red solid 0.5px;
  background-color: rgb(238, 238, 66);
  color: red;
}
.show-detail-content{
  /* background-color: silver; */
  border: silver solid 5px;
  margin-bottom: 1em;
  margin-left: 0.1em;
  /* margin-right: 0.5em; */
  margin-top: 1em;
  padding: 1em;
  border-radius: 20px;
}
.thong-tin{
  border-radius: 10px 10px 10px 10px;
  background-color: #34baeb;
  color: white;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-bottom: 1em;
  margin-top: 1em;
}
.video-player{
  float: left;
  margin-top: 1em;
  margin-bottom: 1em;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.lien-he{
    padding:3px;
    border-radius:3px;
    border: 1px solid blue;
    color: blue;
    margin-bottom: 2px;
    cursor: pointer;
    width: 40%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2px;
    font-size: 10px;
}

/* image modal */
.modal-mask {
  position: fixed;
  z-index: 9998 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
